exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-produto-carrinho{position:relative}.similar-button{position:absolute;z-index:2;top:48px;right:8px;width:34px;height:34px}.similar-button i{font-size:19px;line-height:34px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ab1c4c8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/carrinhoView/CardProduto.vue
// module id = 290
// module chunks = 130